export const ACREOS_CUSTOM_LINK = "acreos-custom-link";
export const ACREOS_CUSTOM_LINK_ACTIVE = "acreos-custom-link active";

export const ACREOS_CUSTOM_LINK_STYLES = [ACREOS_CUSTOM_LINK, ACREOS_CUSTOM_LINK_ACTIVE];
